// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__165fC","info":"PatientInfo_info__1FEAo"};